module.exports = __webpack_public_path__ + "static/media/projects-text-sk.c39fd646.svg";